import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { AuthContext } from "../../contexts/AuthContext";

function Home() {
  // const { isAuth } = useContext(AuthContext);

  const navigate = useNavigate();

  // function handleClick() {
  //   navigate("/login");
  // }
  return (
    <>
       {/* <Header /> */}
      <br />
      <img
        src="/LogoSistemify2.png"
        height="90%"
        width="90%"
        alt= 'auto'
        className="imgLogo"
        onClick={() => navigate("/login")}
      />
    </>
  );
}

export default Home;
